const filesMobile = (state = {
    upload: []
}, action) => {
    switch (action.type) {
        case 'APP_MOBILE_SET_UPLOAD_PROGRESS':
            if (state.upload.some(u => u.id === action.payload.id)) {
                return Object.assign({}, state, {
                    upload: [...state.upload].map(u => {
                        if (u.id === action.payload.id) {
                            return {
                                ...u,
                                progress: action.payload.progress
                            }
                        }

                        return u;
                    })
                });
            }

            return Object.assign({}, state, {
                upload: [...state.upload, action.payload]
            });

        case 'APP_MOBILE_SET_UPLOAD_COMPLETED':
            return Object.assign({}, state, {
                upload: state.upload.filter(u => u.id !== action.payload.id)
            });

        default:
            return state;
    }
};

export default filesMobile;
